const INFO_KEY = 'SMUPA_MASSAGE_INFO'

export const getInfo = () => {
  const defaultInfo = { token: '' }
  const result = localStorage.getItem(INFO_KEY)
  return result ? JSON.parse(result) : defaultInfo
}

export const setInfo = (obj) => {
  localStorage.setItem(INFO_KEY, JSON.stringify(obj))
}

export const removeInfo = () => {
  localStorage.removeItem(INFO_KEY)
}

// Device List
export const setDeviceList = (list) => {
  localStorage.setItem(INFO_KEY + '_deviceList', JSON.stringify(list))
}

export const getDeviceList = () => {
  const result = localStorage.getItem(INFO_KEY + '_deviceList')
  return result ? JSON.parse(result) : []
}

export const removeDeviceList = () => {
  localStorage.removeItem(INFO_KEY + '_deviceList')
}
